import { createSlice } from "@reduxjs/toolkit";
import { clearCategoryFilter, clearLocationFilter } from "../../helpers/utility";


const initialState = {
  isExportCreatorModal: false,
  isDropdownEnable: false,
  creatorsList: [],
  shortlistCreators: [],
  shortlistCount: 0,
  shortlistTotalPages: 0,
  count: 0,
  totalPages: 0,
  page: 1,
  creatorsLoading: false,
  shortlistCreatorsLoading: false,
  loaderForButton: false,
  selectedCreators: [],
  selectedShortlisted: [],
  selectedRisingStars: [],
  shortlist: {
    _id: "",
    shortListName: ""
  },
  animetaVerifiedToggle: false,
  animetaCertifiedToggle: false,
  snapStartToggle: false,
  instantDealsToggle: false,
  celebrityToggle: null,
  filterData: {},
  activeResult: "grid",
  headerSocialMedia: 'instagram',
  sort: {
    sortBy: "followers",
    sortOrder: -1,
  },
  filter: false,
  filterTags: [],
  performanceFilter: false,
  audienceToggle: false,
  storyToggle: false,
  spotlightToggle: false,
  isAllSelected: false,
  selectAll: false,
  deselected: [],
  isFilterOpen: false,
  socialMedia: {
    platform: [],
    followers: {
      min: 0,
      max: 1000000000,
    },
    views: {
      min: 0,
      max: 1400000000,
    },
    engagement: {
      min: 0,
      max: 1000000000,
    },
    average_views: {
      min: 0,
      max: 1000000000,
    },
    postShares: {
      min: 0,
      max: 1000000000,
    },
    reelShares: {
      min: 0,
      max: 1000000000,
    },
    spotLightViews: {
      min: 0,
      max: 1800000000,
    },
    reach: {
      min: 0,
      max: 1800000000,
    },
    story_views: {
      min: 0,
      max: 100000000,
    },
    lens_views: {
      min: 0,
      max: 700000000,
    },
    avg_time_spent: {
      min: 0,
      max: 500000000,
    },
    engagement_rate: {
      min: 0,
      max: 500000000,
    },

  },
  genre: [],
  intrest: [],
  creatorSize: [],
  search: "",
  gender: [],
  location: [
    {
      name: "India",
      isActive: false,
      isOpened: false,
      isDisabled: true,
      search: "",
      isPartial: false,
      states: []
    }
  ],
  audienceLocation: [
    {
      name: "India",
      search: "",
      isActive: false,
      isOpened: false,
      isDisabled: true,
      isPartial: false,
      states: []
    }
  ],
  category: [
    {
      name: "All",
      isActive: false,
      isOpened: false,
      isDisabled: true,
      search: "",
      isPartial: false,
      subCategory: []
    }
  ],
  targetAudience: [
    { name: "Gen Z", code: "13-24", male: false, female: false, showGenz: true },
    { name: "13 - 17", code: "13-17", male: false, female: false, showGenz: false },
    { name: "18 - 24", code: "18-24", male: false, female: false, showGenz: false },
    { name: "25 - 34", code: "25-34", male: false, female: false, showGenz: false },
    { name: "35 - 44", code: "35-44", male: false, female: false, showGenz: false },
    { name: "45 - 64", code: "45-64", male: false, female: false, showGenz: false }
  ],
  creatorIntrestToggle: false,
  contentCategoryToggle: false,
  creatorPerformanceToggle: false,
  creatorTypeToggle: false,
  creatorLocationToggle: false,
  snapGenreToggle: false,
  audienceTargetToggle: false,
  creatorSizeToggle: false,
  wordFilterToggle: false,
  notesFilterToggle: false,
  filterCount: 1,
  filterButton: false,
  filterTab: 'creator_filter',
  filterLoading: false,
  delist: false,
  advanceMetricToggle: false,
  contentLanguageToggle: false,
  contentMultiLanguageToggle: false,
  contentLanguage: [],
  contentMultiLanguage: [],
  collabStatus: 1,
  mylistRowViewLoader: false,
  socialCommerceToggle: false,
  creatorContentGenre: "Primary",
  creatorLanguageOptions: "Single",
  primaryLanguage: null,
  selectedAudienceTypeForAgePerGender: null,
  selectedAudienceMetricType: null,
  minValueForAgePerGender: 13,
  maxValueForAgePerGender: 64,
  minPercentForAgePerGender: 0,
  spolightViewMinValueForAgePerGender: 13,
  spolightViewMaxValueForAgePerGender: 35,
  spolightViewMinPercentForAgePerGender: 0,
  spotlightGenderPercentage: 0,
  spolightViewSelectedAudienceTypeForAgePerGender: null,
  storyViewMinValueForAgePerGender: 13,
  storyViewMaxValueForAgePerGender: 35,
  storyViewMinPercentForAgePerGender: 0,
  storyGenderPercentage: 0,
  storyViewSelectedAudienceTypeForAgePerGender: null,
  isAudienceCohert: undefined,
  isGenZ: false,
  selectedCreatorAllInfo: [],
  individualCreatorToggle: null,
  filtersApplied: {},
  creatorModality: [],
  creatorModalityToggle: false,
  pricingDetails: null,
  pricingDetailsToggle: false,
  mobileNo: null,
  mobileNoToggle: false,
  emailId: null,
  emailIdToggle: false,
  creatorShortListData: {},
  creatorAffiliateCampaignAvailability: undefined,
  showNormalizedView: false,
  isFollowers: false,
  isView: false,
  isEngagement: false,
  isAvgView: false,
  isAvgPostShares: false,
  isAvgReelShares: false,
  isEngRate: false,
  isSpotLightViews: false,
  isReach: false,
  isStoryViews: false,
  isLensviews: false,
  isAvgTimeSpent: false,
  hashtags: [],
  mentions: [],
  keywords: '',
  notes: '',
  searchData: { searchText: "", type: null },
  filterLoader: false,
  disableExport: false,
  scrollPosition: 0,
  exportExcelListData: [],
  exportExcelFilterButtonLoader: true,
  isPublished: false,
}
const creatorSlice = createSlice({
  name: "creators",
  initialState,
  reducers: {
    setCreatorList(state, action) {
      state.creatorsList = action?.payload?.pagination ? [...state.creatorsList, ...action.payload?.creatorsList] : action.payload?.creatorsList
      state.count = action.payload?.count ?? 0
      state.creatorsLoading = action.payload?.creatorsLoading ?? false
      state.totalPages = action.payload?.totalPages ?? 0
      state.loaderForButton = action.payload?.loaderForButton ?? false
      state.page = action.payload?.page ?? 0

    },

    setShowNormalizedView(state, action) {
      state.showNormalizedView = action.payload
    },
    // Set My list Paginations
    setShortListPaginationData(state, action) {
      state.shortLists = action?.payload?.pagination ? [...state?.shortLists, ...action?.payload?.shortLists] : action?.payload?.shortLists
    },

    setCreatorLoading(state, actions) {
      state.creatorsLoading = actions.payload
    },
    setShortlistCreatorsLoading(state, actions) {
      state.shortlistCreatorsLoading = actions.payload
    },
    setSocialMediaPlatform(state, actions) {
      state.socialMediaPlatform = actions.payload
    },
    setLoaderForButton(state, actions) {
      state.loaderForButton = actions.payload
    },
    selectCreator(state, action) {
      state.selectedCreators = [...state.selectedCreators, action.payload]
    },
    selectAllCreator(state, action) {
      state.selectedCreators = action.payload;
    },

    selectAllShortlist(state, action) {
      state.selectedShortlisted = action.payload;
    },

    selectShortlisted(state, action) {
      state.selectedShortlisted = [...state.selectedShortlisted, action.payload]
    },

    deselectShortlisted(state, action) {
      state.selectedShortlisted = state.selectedShortlisted.filter(
        (item) => !(item?._id === action.payload?._id && item?.platform === action?.payload?.platform))
    },

    setDropdownEnabled(state, action) {
      state.isDropdownEnable = action.payload
    },
    deselectCreator(state, action) {
      state.selectedCreators = state.selectedCreators.filter(
        (item) => !(item?._id === action.payload?._id && item?.platform === action?.payload?.platform))
    },

    selectRisingstar(state, action) {
      state.selectedRisingStars = [...state.selectedRisingStars, action.payload]
    },

    selectAllRisingstar(state, action) {
      state.selectedRisingStars = action.payload;
    },
    deselectRisingstar(state, action) {
      state.selectedRisingStars = state.selectedRisingStars.filter(
        (item) => !(item?._id === action.payload?._id && item?.platform === action?.payload?.platform))
    },
    clearSelectedCreators(state, action) {
      state.selectedCreators = []
    },
    setSelectedCreators(state, actions) {
      state.selectedCreators = actions.payload
    },
    setShortlist(state, action) {
      state.shortlist = action?.payload
    },
    setShortlistCreators(state, action) {
      state.creatorShortListData = action?.payload?.creatorShortListData ?? {}
      state.shortlistCreators = action?.payload?.pagination ? [...state.shortlistCreators, ...action.payload?.shortlistCreators] : action.payload?.shortlistCreators
      state.shortlistCount = action.payload?.count ?? 0
      state.shortlistCreatorsLoading = action.payload?.shortlistCreatorsLoading ?? false
      state.shortlistTotalPages = action.payload?.totalPages ?? 0
      state.loaderForButton = action.payload?.loaderForButton ?? false
    },
    setCreatorStates(state, action) {
      const { payload: { key, value } } = action
      state[key] = value;
      return state
    },
    setMyListRowViewLoader(state, action) {
      state.mylistRowViewLoader = action.payload
    },
    clearLocation(state, action) {
      state[action?.payload] = clearLocationFilter([...state?.[action.payload]])
      return state
    },
    clearCategory(state, action) {
      state[action?.payload] = clearCategoryFilter([...state?.[action.payload]])
      return state
    },
    clearTargetAudienceCohort(state) {
      state.targetAudience = initialState.targetAudience
      state.selectedAudienceMetricType = initialState.selectedAudienceMetricType
    },
    clearTargetAudience(state) {
      const { selectedAudienceTypeForAgePerGender, minValueForAgePerGender, maxValueForAgePerGender, minPercentForAgePerGender }
        = initialState;
      state = {
        ...state,
        selectedAudienceTypeForAgePerGender, minValueForAgePerGender, maxValueForAgePerGender, minPercentForAgePerGender
      }
      return state
    },
    clearCreator(state, action) {
      return initialState;
    },
    setExportCreatorModal(state, action) {
      state.isExportCreatorModal = action.payload
    },
    clearCreatorTempData(state, action) {
      const { shortlistCreatorsLoading, ...rest } = initialState
      return { ...state, ...rest }
    },
    setSelectedCreatorAllInfo(state, action) {
      state.selectedCreatorAllInfo = [...state.selectedCreatorAllInfo, ...action?.payload]
    },
    applyFilter(state, action) {
      const {
        socialMedia, creatorSize, genre, intrest, celebrityToggle, location, audienceLocation, targetAudience,
        gender, contentLanguage, selectedAudienceTypeForAgePerGender, selectedAudienceMetricType,
        minValueForAgePerGender, maxValueForAgePerGender, minPercentForAgePerGender, individualCreatorToggle,
        spolightViewMinValueForAgePerGender, spolightViewMaxValueForAgePerGender, spolightViewMinPercentForAgePerGender, spotlightGenderPercentage, spolightViewSelectedAudienceTypeForAgePerGender,
        storyViewMinValueForAgePerGender, storyViewMaxValueForAgePerGender, storyViewMinPercentForAgePerGender, storyGenderPercentage, storyViewSelectedAudienceTypeForAgePerGender,
        creatorModality, pricingDetails, emailId, mobileNo, creatorAffiliateCampaignAvailability, creatorContentGenre, primaryLanguage, contentMultiLanguage,
        hashtags, keywords, mentions, category, notes
      } = state
      state.filtersApplied = {
        socialMedia, creatorSize, genre, intrest, celebrityToggle, location, audienceLocation, targetAudience,
        gender, contentLanguage, selectedAudienceTypeForAgePerGender, selectedAudienceMetricType,
        minValueForAgePerGender, maxValueForAgePerGender, minPercentForAgePerGender, individualCreatorToggle,
        spolightViewMinValueForAgePerGender, spolightViewMaxValueForAgePerGender, spolightViewMinPercentForAgePerGender, spotlightGenderPercentage, spolightViewSelectedAudienceTypeForAgePerGender,
        storyViewMinValueForAgePerGender, storyViewMaxValueForAgePerGender, storyViewMinPercentForAgePerGender, storyGenderPercentage, storyViewSelectedAudienceTypeForAgePerGender,
        creatorModality, pricingDetails, emailId, mobileNo, creatorAffiliateCampaignAvailability, creatorContentGenre, primaryLanguage, contentMultiLanguage,
        hashtags, keywords, mentions, category, notes
      }
      return state
    },
    //Clear function for audience filter metric data
    clearAudienceMetric(state, action) {
      const resetFields = {
        spotlight_views: [
          "spolightViewMinValueForAgePerGender",
          "spolightViewMaxValueForAgePerGender",
          "spolightViewMinPercentForAgePerGender",
          "spotlightGenderPercentage",
          "spolightViewSelectedAudienceTypeForAgePerGender"
        ],
        story_views: [
          "storyViewMinValueForAgePerGender",
          "storyViewMaxValueForAgePerGender",
          "storyViewMinPercentForAgePerGender",
          "storyGenderPercentage",
          "storyViewSelectedAudienceTypeForAgePerGender"
        ]
      };

      // Get the fields to reset based on action.payload (either 'spotlight_views' or 'story_views')
      const fieldsToReset = resetFields[action.payload];

      if (fieldsToReset) {
        fieldsToReset.forEach((field) => {
          state[field] = initialState[field]; // Reset each field to its initial value
        });
      }

      return state;
    },

    setSearchData(state, action) {
      state.searchData = action?.payload
    },
    setDisableExport(state, action) {
      state.disableExport = action?.payload
    }
    // setIndividualCreatorToggle(state, action){
    //   state.individualCreatorToggle = action.payload
    // }
  }

})

export const creatorActions = creatorSlice.actions;

export default creatorSlice;